import React from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/main.scss';
import FormContainer from '@/containers/FormContainer';

const globalCssNamespace = 'forsikring-kontaktskjema';

const container = document.getElementById('kontaktskjema-app');
const root = createRoot(container!);
root.render(
    <div className={globalCssNamespace}>
        <FormContainer />
    </div>,
);
